import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';
import { H3BasicMaterial } from '../basic/h3-basic-material';
import { H3SharedUniforms } from '../shared/definitions';

export interface CuboidUniforms extends H3SharedUniforms {
  offset: Point3D;
}

export class CuboidMaterial extends H3BasicMaterial<CuboidUniforms> {
  constructor() {
    super();
    this.defines.IS_CUBOID = true;
  }
}
